import ActionUtility from "../../utilities/ActionUtility";
import LocationEffect from "./LocationEffect";

export default class LocationAction {
  // LocationAction action with an function declaration
  static REQUEST_LOCATION = "LocationAction.REQUEST_LOCATION";
  static REQUEST_LOCATION_FINISHED = "LocationAction.REQUEST_LOCATION_FINISHED";

  // METHODS
  static requestLocation(params) {
    return async (dispatch, getState) => {
      await ActionUtility.createThunkEffect(
        dispatch,
        LocationAction.REQUEST_LOCATION,
        LocationEffect.requestLocation,
        params
      );
    };
  }
}
